export default function Benefits() {
  const stats = [
    { value: '250+', label: 'Spreadsheet Templates' },
    { value: '15+', label: 'In-Depth Guides' },
    { value: '10K+', label: 'Monthly Readers' },
  ];

  const features = [
    {
      icon: 'ri-layout-grid-line',
      title: 'Better Organization',
      description: 'Structure your data with intuitive spreadsheets that keep everything neatly categorized and instantly accessible.',
    },
    {
      icon: 'ri-speed-line',
      title: 'Faster Tracking',
      description: 'Streamline your workflow with pre-built formulas and automated calculations that save hours of manual work.',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Improved Data Visibility',
      description: 'Gain clear insights with visual dashboards and reports that highlight trends and opportunities at a glance.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Easier Inventory Management',
      description: 'Maintain accurate stock levels and order histories without relying on scattered notes or outdated records.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-5/12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-5">
              Why Use a LitBuy
              <br />
              Spreadsheet System?
            </h2>
            <p className="text-base text-foreground-600 mb-8 leading-relaxed">
              A well-designed spreadsheet transforms how you manage data. From tracking
              inventory to analyzing trends, LitBuy spreadsheet resources give you the
              structure and efficiency that manual methods simply cannot match.
            </p>

            <div className="grid grid-cols-3 gap-6 border-t border-background-300/60 pt-8">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="text-3xl md:text-4xl font-bold text-accent-500 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-7/12">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((feat) => (
                <div
                  key={feat.title}
                  className="p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className={`${feat.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    {feat.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}